import { render, staticRenderFns } from "./BaseRegions.vue?vue&type=template&id=6def4cb8"
import script from "./BaseRegions.vue?vue&type=script&lang=js"
export * from "./BaseRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports